import { z } from 'zod';

export const HelioResultStatus = z.enum([
  'HISTORIC',
  'CURRENT',
  'CALCULATED',
  'FAILED',
  'LOCKED',
]);

export type HelioResultStatusT = z.infer<typeof HelioResultStatus>;
